module.exports = __webpack_public_path__ + "media/images/canvas_logo_square_36-9bfb1d3ee4faabc1b455b37ad72f739c.png";